import Component,{register} from '@services/component'
import {classes,find} from '@services/dom'

export default register(
    class PageNavigation extends Component{
        static selector = '.page-navigation'

        static inversionRules = [
            '#page-content > .hero.is-gradient:first-child',
            '#page-content > .hero.is-primary:first-child',
            '#page-content > .hero.is-secondary:first-child',
            '#page-content > .hero.is-dark:first-child',
            '#page-content > .content-type-gridelements_pi1.is-gradient:first-child',
            '#page-content > .content-type-gridelements_pi1.is-primary:first-child',
            '#page-content > .content-type-gridelements_pi1.is-secondary:first-child',
            '#page-content > .content-type-gridelements_pi1.is-dark:first-child',
        ]

        state = {
            inverted:false,
            scrolled:false,
        }

        create() {
            let inverted = false;

            for(let rule of this.constructor.inversionRules) {
                if(find(rule).length) {
                    inverted = true;
                    break;
                }
            }

            this.on(window,'scroll',()=>{
                this.setState({ scrolled:window.scrollY > 88 });
            })

            this.setState({ inverted, scrolled:window.scrollY > 88 });
        }

        async render() {
            const {inverted,scrolled} = this.state;
            classes(this.el,'page-navigation',{'is-inverted':inverted});
            document.documentElement.classList.toggle('is-scrolled',scrolled);
        }
    }
);